export enum AgreementProduct {
  NATURA = 'natura',
  DIGITAL_STORE = 'digital-store',
  BUREAU = 'bureau',
  RESELLER = 'reseller',
  AVON_WEBSITE_USAGE = 'website-usage',
  AVON_PRIVACY_POLICY = 'privacy-policy',
}
